const Links = {
    limpiezaCasas: "/servicios/limpieza-casas-panama",
    limpiezaApartamentos: "/servicios/limpieza-apartamentos-panama",
    limpiezaOficinas: "/servicios/limpieza-oficinas-panama",
    limpiezaEventos: "/servicios/limpieza-eventos-panama",
    limpiezaAirbnb: "/servicios/limpieza-airbnb-panama",
    limpiezaMudanzas: "/servicios/limpieza-mudanzas-panama",
    limpiezaApartamentosModelo: "/servicios/limpieza-apartamentos-modelo-panama",
    contacto: "/contactar-servicio-limpieza-panama",
    reservar: "https://wa.me/50760204010?text=Buenos%20dias!%20Me%20gustaria%20reservar%20un%20servicio%20de%20limpieza...",
    servicios: "/servicios",
    facebook: "https://www.facebook.com/maidpanamacom",
    instagram: "https://www.instagram.com/maidpanama",
    twitter: "https://x.com/MaidPanama"
}

export default Links;
